// public
export const LogoutPage = '/logout';
export const DriverLogoutPage = '/logout-driver';
export const LoginPage = '/login';
export const LoginByEmailPage = '/login-by-email';
export const DriverLoginPage = '/s/:driverId';
export const DriverUnauthorizedPage = '/s/unauthorized';
export const ConfirmEmailPage = '/confirm-email';
export const ResetPasswordByEmailPage = '/reset-password-by-email';
export const ResetPasswordPage = '/reset-password/:accessToken?';
export const TokenLoginPage = '/tokenLogin/:token';
export const RegistrationByInviteLinkPage = '/registration-from-link/:id?';
export const UnsecuredDriverLoginPage = '/upload';

// driver
export const DriverDocumentsPage = '/driver/documents';
export const ScanPage =
  '/driver/documents/scan/:documentType/:documentTypeEnum/:documentRequestId/:documentId/*';
export const ScanPageWizardStep1 =
  '/driver/documents/scan/:documentType/:documentTypeEnum/:documentRequestId/:documentId/step-1';
export const ScanPageWizardStep2 =
  '/driver/documents/scan/:documentType/:documentTypeEnum/:documentRequestId/:documentId/step-2';
export const ScanPageWizardStepScan =
  '/driver/documents/scan/:documentType/:documentTypeEnum/:documentRequestId/:documentId/scan';

export const ManualUpload =
  '/driver/documents/scan/:documentType/:documentTypeEnum/:documentRequestId/:documentId/manual-upload';

export const TemporaryLicensePage =
  '/driver/documents/scan/license/DRIVER_LICENSE/:documentRequestId/:documentId/temporary-license';
export const DOTMedicalQuestionsPage =
  '/driver/documents/scan/dot-med/DOT_MEDICAL/:documentRequestId/:documentId/dot-medical-questions';
export const ThatSItPage = '/driver/documents/that-s-it';
export const OneMoreThingPagePath = '/driver/documents/one-more-thing';

export const DriverCheckListPagePath = '/driver/documents/checklist';

//dashboard
export const DashboardPage = '/dashboard';
export const ReportPagePath = '/dashboard/report';
export const DashboardDriversPage = '/dashboard/drivers';
export const DashboardDriversReviewPage = '/dashboard/drivers/:id';
